import $ from "jquery";
import sal from "sal.js";
import Swiper, { Autoplay, EffectFade, Navigation, Pagination } from 'swiper';
import _ from 'lodash';

Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);

const mq = (device) => {
  if (window.matchMedia('(max-width:768px)').matches && device === 'sp') {
    return true;
  }
  return window.matchMedia('(min-width:769px)').matches && device === 'pc';
};

// Menu UI Functions
const menuToggleFunc = () => {
  const mTrigger = document.getElementById("menu-trigger");
  const jsInnerLink = document.querySelectorAll(".js-inner-link");

  jsInnerLink.forEach((element) => {
    element.addEventListener("click", () => {
      if ($('body').hasClass('menu-show')) {
        $('body').removeClass('menu-show');
      }
    });
  });
  mTrigger.addEventListener("click", () => {
    if ($('body').hasClass('menu-show')) {
      $('body').removeClass('menu-show');
    } else {
      $('body').addClass('menu-show');
    }
  });
}

const subPageInitFuntions = () =>{

}


const firstAnimationTop = () =>{



  const firstVideo = document.getElementById("firstVideo");
  const firstCatch = document.getElementById("firstCatch");
  const headerWrap = document.getElementById("headerWrap");


 setTimeout(() => {
    headerWrap.classList.add('show');
  }, 1000);

   setTimeout(() => {
    firstVideo.play();
  }, 2000);
  setTimeout(() => {
    firstCatch.classList.add('is-hide');


  }, 2200);
  // topFirstSlider();

}


const scrollMoveFunc = () => {

  // スクロール量を取得
  const scroll = window.pageYOffset || document.documentElement.scrollTop;

  if(document.getElementById('jsNextCatch') !== null && scroll > 500){
    document.getElementById('jsNextCatch').classList.add('is-show');
  }

  if(document.getElementById('headerWrap') !== null && scroll > 500){
    document.getElementById("headerWrap").classList.add('bg');
  }else if(document.getElementById('headerWrap') !== null && scroll < 500){
    document.getElementById("headerWrap").classList.remove('bg');
  }

  if(document.getElementById('singleHeaderWrap') !== null && scroll > 500){
    document.getElementById("singleHeaderWrap").classList.add('bg');
  }else if(document.getElementById('singleHeaderWrap') !== null && scroll < 500){
    document.getElementById("singleHeaderWrap").classList.remove('bg');
  }

}

const companyLink = () => {

  const companyLinks = document.querySelectorAll('.js-company-link');

  const removeClass = () => {
    companyLinks.forEach(element => {
      element.classList.remove('is-show');
    });
  };

  companyLinks.forEach(element => {
    element.addEventListener('click', (e) => {
      removeClass();
      element.classList.add('is-show');
    });
  });

}

const selectBox = () => {
$('.custom-select').each(function () {
  // eslint-disable-next-line func-names
  const classes = $(this).attr('class');
  const id = $(this).attr('id');
  const name = $(this).attr('name');
  let template = `<div class="${classes}">`;
  template += `<span class="custom-select-trigger">${$(this).attr('placeholder')}</span>`;
  template += '<div class="custom-options">';

  $(this).find('option').each(function () {
    template += `<span class="custom-option ${$(this).attr('class')}" data-value="${$(this).attr('value')}">${$(this).html()}</span>`;
  });

  template += '</div></div>';

  $(this).wrap('<div class="custom-select-wrapper"></div>');
  $(this).hide();
  $(this).after(template);
});

$('.custom-option:first-of-type').hover(
  function () {
    $(this).parents('.custom-options').addClass('option-hover');
  },
  function () {
    $(this).parents('.custom-options').removeClass('option-hover');
  }
);

// custom-select-triggerにクリックイベントを追加
$('.custom-select-trigger').on('click', function (event) {
  $('html').one('click', () => {
    $('.custom-select').removeClass('opened');
  });
  $(this).parents('.custom-select').toggleClass('opened');
  event.stopPropagation();
});

// custom-optionにクリックイベントを追加
$('.custom-option').on('click', function () {
  const value = $(this).data('value');
  const text = $(this).text();

  $(this).parents('.custom-select-wrapper').find('select').val(value);
  $(this).siblings('.custom-option').removeClass('selection');
  $(this).addClass('selection');
  $(this).parents('.custom-select').removeClass('opened');
  $(this).parents('.custom-select').find('.custom-select-trigger').text(text);
});
};



const caseDetailSlider = () => {

  //  .js-case-slider というクラス名がある場合に全てswiperを適用する
  const caseSlider = document.querySelectorAll('.js-case-slider');
  caseSlider.forEach((element) => {
    const swiper = new Swiper(element, {
      loop: true,
      speed: 1000,
      navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
      },
      centeredSlides: true,
      spaceBetween: 60,
    });
  });
}

// .js-target というクラス名を持つ要素を監視し、画面内に入ったら is-active クラスを追加するシンプルな実装
const scrollAnimation = () => {
  // 監視対象の要素をすべて取得
  const targets = document.querySelectorAll(".js-target");
  if (!targets) return; // 監視対象がなければ処理を終了

  // IntersectionObserverのコールバック関数
  const cb = (entries, observer) => {
    entries.forEach((entry) => {
      // 要素がビューポートに入った場合
      if (entry.isIntersecting) {
        // 要素にクラスを追加
        entry.target.classList.add("is-active");
        // 監視を解除
        observer.unobserve(entry.target);
      }
    });
  };

  // IntersectionObserverのオプション設定
  const options = {
    root: null, // ビューポートを基準にする
    rootMargin: "0px", // ビューポートのマージンを設定
    threshold: 0.3, // 要素が少しでも表示されたら発火
  };

  // IntersectionObserverのインスタンスを作成
  const io = new IntersectionObserver(cb, options);

  // 監視対象の各要素を監視
  targets.forEach((target) => {
    io.observe(target);
  });
};

const headerShow = () => {
  const headerWrap = document.getElementById("headerWrap");

 setTimeout(() => {
    headerWrap.classList.add('show');
  }, 1000);
}

const formCheck = () => {
  // エラーを表示する関数（error クラスの p 要素を追加して表示）
  function showError(message, this$) {
    let text = this$.parent().find("label").text() + message;
    this$.parent().append(`<p class='error'>${text}</p>`);
  }

  // フォームが送信される際のイベントハンドラの設定
  // eslint-disable-next-line consistent-return
  $("#formPage1").submit(() => {
    // エラー表示の初期化
    $("p.error").remove();
    $("div").removeClass("error");
    let text = "";
    $("#errorDispaly").remove();

    // メールアドレスの検証
    let email = $.trim($("#email").val());
    if (
      email &&
      // eslint-disable-next-line no-useless-escape
      !/^([a-z0-9\+_\-]+)(\.[a-z0-9\+_\-]+)*@([a-z0-9\-]+\.)+[a-z]{2,6}$/gi.test(email)
    ) {
      $("#email").after("<p class='error'>メールアドレスの形式が異なります</p>");
    }
    // 電話番号の検証
    let tel = $.trim($("#tel").val());
    if (
      tel &&
      // eslint-disable-next-line no-useless-escape
      !/^\(?\d{2,5}\)?[-(\.\s]{0,2}\d{1,4}[-)\.\s]{0,2}\d{3,4}$/gi.test(tel)
    ) {
      $("#tel").after("<p class='error'>電話番号の形式が異なります（半角英数字でご入力ください）</p>");
    }
    // カナの検証
    let kana = $.trim($("#kana").val());
    if (kana && !kana.match(/^[ァ-ヶー]+$/)) {
      $("#kana").after("<p class='error'>全角カタカナではない文字が含まれています</p>");
    }
    // 1行テキスト入力フォームとテキストエリアの検証
    $(":text,textarea")
      .filter(".validate")
      // eslint-disable-next-line func-names
      .each(function () {
        // 必須項目の検証
        $(this)
          .filter(".required")
          // eslint-disable-next-line func-names
          .each(function () {
            if ($(this).val() === "") {
              showError("必須項目です", $(this));
            }
          });
        // 文字数の検証
        $(this)
          .filter(".max30")
          // eslint-disable-next-line func-names
          .each(function () {
            if ($(this).val().length > 30) {
              showError(" は30文字以内です", $(this));
            }
          });
        $(this)
          .filter(".max50")
          // eslint-disable-next-line func-names
          .each(function () {
            if ($(this).val().length > 50) {
              showError(" は50文字以内です", $(this));
            }
          });
        $(this)
          .filter(".max100")
          // eslint-disable-next-line func-names
          .each(function () {
            if ($(this).val().length > 100) {
              showError(" は100文字以内です", $(this));
            }
          });
        $(this)
          .filter(".max1000")
          // eslint-disable-next-line func-names
          .each(function () {
            if ($(this).val().length > 1000) {
              showError(" は1000文字以内でお願いします", $(this));
            }
          });
      });

    // error クラスの追加の処理
    if ($("p.error").length > 0) {
      $("p.error").parent().addClass("error");
      $("html,body").animate({ scrollTop: $("p.error:first").offset().top - 180 }, "slow");
      return false;
    }
  });
};


window.addEventListener('DOMContentLoaded', (event) => {
  sal();
  scrollAnimation();
  // smoothScrollFromAnchor(".js-smooth-scroll");
   if(document.getElementById('casePage') || document.getElementById('caseDetailPage')){
    selectBox();
  }

  if(document.getElementById('menu-trigger')){
    menuToggleFunc();
  }

  if(document.getElementById('companyPage')){
    companyLink();
  }
 if(document.getElementById('caseDetailPage')){
    caseDetailSlider();
  }
  if(document.getElementById('topPage')){
    firstAnimationTop();
  }
  if(document.getElementById('subPage')){
    subPageInitFuntions();
    headerShow();
  }

  if(document.getElementById('formPage1')){
    formCheck();
  }

});

window.addEventListener('scroll', _.throttle(scrollMoveFunc, 350));
